import { states as options } from "../states/index.js";
import { COMMON_FIELDS } from "../commonFields/index.js";

export const jobs = {
  tableId: "bsw4vqjfg", // The tableId for the jobs table
  fetchFilter: "{16.EX.'A'}", //Status is active
  fields: [
    ...COMMON_FIELDS,
    { id: 3, label: "recordId", type: "number" },
    { id: 6, label: "jobNumber", type: "key" },
    { id: 7, label: "jobName", type: "string" },
    { id: 16, label: "status", type: "string" },
    { id: 99, label: "customerName", type: "number" },
    { id: 423, label: "location", type: "string" },
    { id: 424, label: "street1", type: "string", editable: true },
    { id: 425, label: "street2", type: "string", editable: true },
    { id: 426, label: "city", type: "string", editable: true },
    { id: 427, label: "state", type: "string", editable: true, options },
    { id: 428, label: "postalCode", type: "string", editable: true },
    { id: 453, label: "numTickets", type: "number", editable: false },
  ],
};
